import React from 'react'

function Benefits() {
  return (
    <div>Benefits</div>
  )
}

export default Benefits